import React, { ReactElement } from 'react';
import {
  // TextField as MuTextField,
  StandardTextFieldProps,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import { Control, Controller } from 'react-hook-form';
import useStyles from '../styles';

interface IIcon {
  position: 'left' | 'right';
  Component: ReactElement;
}

interface Iprops
  extends Omit<StandardTextFieldProps, 'onChange' | 'value' | 'variant'> {
  control: Control;
  rules: any;
  variant: 'standard' | 'outlined' | 'filled';
  icon?: IIcon;
  name: string;
  onFocus?: any;
}

export default function TTextField(props: Iprops) {
  const { control, icon, rules, ...other } = props;
  const classes = useStyles();
  var defaultInputProps = {
    classes: {
      notchedOutline: classes.notchedOutline,
    },
  };

  return (
    <Controller
      render={({ value, onChange, ...rest }) => (
        <TextField
          value={value || ''}
          onChange={onChange}
          {...rest}
          {...other}
          InputProps={{
            ...(defaultInputProps as any),
            ...other.InputProps,
            ...(icon &&
              icon.position === 'right' && {
                endAdornment: (
                  <InputAdornment position="end">
                    {icon.Component}
                  </InputAdornment>
                ),
              }),
            ...(icon &&
              icon.position === 'left' && {
                startAdornment: (
                  <InputAdornment position="start">
                    {icon.Component}
                  </InputAdornment>
                ),
              }),
          }}
        />
      )}
      name={other.name}
      control={control}
      rules={rules}
    />
  );
}
